import DashboardMoniteringSub from 'pages/monitoring/dashboard/dashboard-sub';
import DashboardNantongMoniteringSub from 'pages/monitoring/dashboard/dashboard-nantong-sub';

const DashboardSubSwitcher = () => {

  const platformServer = process.env.REACT_APP_PLATFORM_SERVER;

  if (platformServer === 'NANTONG') {
      return <DashboardNantongMoniteringSub />;
  }

  return <DashboardMoniteringSub />;
};

export default DashboardSubSwitcher;